import Scenarios from '../Scenarios/Scenarios';

const Dashboard = () => {
  return <Scenarios />;
};
export default Dashboard;
